import React from 'react'

const EmployeeManagement = () => {
  return (
    <div>EmployeeManagement</div>
  )
}

export default EmployeeManagement